import { MatrixClient } from 'matrix-js-sdk/src/matrix';

import { isMatrixUserNotFoundError } from './isMatrixUserNotFoundError';

export async function validateMatrixUserExists(matrixClient: MatrixClient, userId: string): Promise<boolean> {
  try {
    await matrixClient.getProfileInfo(userId);
    return true;
  } catch (error) {
    if (isMatrixUserNotFoundError(error)) return false;
    throw error;
  }
}
